import { TprmRequirementType } from '@evidentid/tprm-portal-lib/models/entity-details';

import { config as appConfig } from '@/config';

export function getRequirementTypeIconUri(coverageType: TprmRequirementType): string {
    return `${appConfig.gatewayApiUrl}tprm-ui/models/icons/requirements/${coverageType}.svg`;
}
